import { buildTranslate } from 'locales'

import { Button } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { PermissionTooltip } from 'components/Navbar/Bar/PermissionTooltip'
import useFlag from 'hooks/useFlag'
import { usePermissionReason } from 'hooks/useRbacNavCheck'
import { useAbility } from 'utilities/ability'

const t = buildTranslate('shared_words')

type PropsT = {
  setIsEditModalOpen: (value: boolean) => void
}

const EditButton = ({ setIsEditModalOpen }: PropsT) => {
  const isEditableLocationPhoneEnabled = useFlag(
    'MX-Editable-Location-PhoneNumber',
    false
  )
  const ability = useAbility()
  const cannotEditLocations = ability.cannot('manage', 'Locations')
  const editDisabledReason = usePermissionReason(
    'Locations',
    cannotEditLocations,
    '(view and edit)'
  )

  return (
    <Switch condition={isEditableLocationPhoneEnabled}>
      <PermissionTooltip
        disabled={cannotEditLocations}
        reason={editDisabledReason}
        id="edit-location-detail-perm"
        placement="top"
      >
        <Button
          className="ml-s"
          type="button"
          kind="secondary"
          onClick={() => setIsEditModalOpen(true)}
          disabled={cannotEditLocations}
        >
          {t('edit')}
        </Button>
      </PermissionTooltip>
    </Switch>
  )
}

export default EditButton
